import React from 'react'
import PublicLayout from '@/pages/PublicLayout'
import Simple from '@/components/layouts/AuthLayout/Simple'
import { ForgotPasswordBase } from '@/components/pages/auth/ForgotPassword'
import { Head } from '@inertiajs/react'

const ForgotPasswordPage = () => {
    return (
        <>
            <Head>
                <title>Forgot Password</title>
                <meta
                    name="description"
                    content="Request a MemoSlate password reset link for your account."
                />
            </Head>
            <Simple>
                <ForgotPasswordBase />
            </Simple>
        </>
    )
}

ForgotPasswordPage.layout = (page: React.ReactNode) => (
    <PublicLayout children={page} />
)

export default ForgotPasswordPage
